/* src/app/pagination-loader/pagination.component.scss */
.paginate-loader {
  width: 100%;
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.92);
  animation: loader-fade-in 0.2s ease-out;
}
.paginate-loader__dots {
  display: flex;
  align-items: center;
  gap: 5px;
}
.paginate-loader__dots span {
  width: 7px;
  height: 7px;
  display: block;
  border-radius: 50%;
  background: #6366f1;
  animation: paginate-dot 1.2s ease-in-out infinite;
}
.paginate-loader__dots span:nth-child(2) {
  animation-delay: 0.15s;
}
.paginate-loader__dots span:nth-child(3) {
  animation-delay: 0.3s;
}
.paginate-loader__text {
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
}
@keyframes paginate-dot {
  0%, 60%, 100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  30% {
    opacity: 1;
    transform: translateY(-4px);
  }
}
@keyframes loader-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 576px) {
  .paginate-loader {
    min-height: 56px;
    padding: 12px 16px;
  }
  .paginate-loader__dots span {
    width: 6px;
    height: 6px;
  }
  .paginate-loader__text {
    font-size: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .paginate-loader,
  .paginate-loader__dots span {
    animation: none;
  }
}
/*# sourceMappingURL=pagination.component.css.map */
